import React from 'react';
import { TrendingUp, Network, Lightbulb, Award } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';

const iconMap = {
  TrendingUp,
  Network,
  Lightbulb,
  Award
};

export const WhySection = () => {
  const { settings } = useSettings();
  const { t, getBilingualValue } = useLanguage();

  // Why cards with i18n keys
  const whyCards = [
    {
      icon: 'TrendingUp',
      titleKey: 'why.marketGrowth',
      descKey: 'why.marketGrowthDesc'
    },
    {
      icon: 'Network',
      titleKey: 'why.globalNetwork',
      descKey: 'why.globalNetworkDesc'
    },
    {
      icon: 'Lightbulb',
      titleKey: 'why.innovationHub',
      descKey: 'why.innovationHubDesc'
    },
    {
      icon: 'Award',
      titleKey: 'why.credibility',
      descKey: 'why.credibilityDesc'
    }
  ];
  
  return (
    <section id="why" className="container mx-auto px-6 py-20">
      <div className="flex flex-col lg:flex-row gap-16">
        <div className="lg:w-1/2">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            {getBilingualValue(settings.why?.title, 'why.title')}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            {getBilingualValue(settings.why?.description, 'why.description')}
          </p>
        </div>
        <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {whyCards.map((card, idx) => {
            const IconComponent = iconMap[card.icon];
            return (
              <div
                key={card.titleKey}
                className="p-6 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1"
              >
                {IconComponent && <IconComponent size={28} style={{ color: settings.colors?.primary || '#0E7A5F' }} className="mb-4" />}
                <h3 className="font-bold text-lg mb-2">{t(card.titleKey)}</h3>
                <p className="text-gray-600 text-sm">{t(card.descKey)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
